import { render, staticRenderFns } from "./DatatableFluids.vue?vue&type=template&id=3b88e930&scoped=true"
import script from "./DatatableFluids.vue?vue&type=script&lang=js"
export * from "./DatatableFluids.vue?vue&type=script&lang=js"
import style0 from "./DatatableFluids.vue?vue&type=style&index=0&id=3b88e930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88e930",
  null
  
)

export default component.exports